import React, { ReactNode } from 'react'

import { treeData } from 'data'
import { loadTree } from 'data/load'

const TreeVersion = React.createContext<number>(0)

export const useTreeVersion = () => React.useContext(TreeVersion)
export const useTreeData = () => treeData(React.useContext(TreeVersion))
export function useTreeNodes(atlas?: boolean) {
  const data = treeData(React.useContext(TreeVersion))!
  if (atlas) {
    return (data.atlas_passive_tree_league ?? data.atlas_passive_tree).nodes
  } else {
    return data.passive_tree.nodes
  }
}

export default function WithTreeData({
  version,
  children
}: {
  version: number
  children: ReactNode
}) {
  const [, setLoaded] = React.useState(0)
  React.useEffect(() => {
    let alive = true
    loadTree(version).then(() => {
      if (alive) setLoaded((v) => v + 1)
    })
    return () => {
      alive = false
    }
  }, [version])
  if (!treeData(version)) return null
  return <TreeVersion.Provider value={version}>{children}</TreeVersion.Provider>
}
